module.exports = __webpack_public_path__ + "img/water-sensor-drain-pan.597786b3.jpg";